
export class LOVProcessedEntityTypeExtension {
}
